import type { TutorialRect } from "./types.js";

/** rects의 union bounding box(+padding)를 컷아웃으로. 빈 배열이면 null. */
export function computeCutout(
  rects: readonly TutorialRect[],
  _unify: boolean,
  padding: number,
): TutorialRect | null {
  if (rects.length === 0) return null;
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;
  for (const r of rects) {
    minX = Math.min(minX, r.x);
    minY = Math.min(minY, r.y);
    maxX = Math.max(maxX, r.x + r.width);
    maxY = Math.max(maxY, r.y + r.height);
  }
  return {
    x: minX - padding,
    y: minY - padding,
    width: maxX - minX + padding * 2,
    height: maxY - minY + padding * 2,
  };
}

export function pointInRect(px: number, py: number, r: TutorialRect): boolean {
  return px >= r.x && px <= r.x + r.width && py >= r.y && py <= r.y + r.height;
}

export type TutorialTextDirection = "ltr" | "rtl";

export function resolveTextDirection(
  option: TutorialTextDirection | (() => TutorialTextDirection) | undefined,
): TutorialTextDirection {
  if (typeof option === "function") return option();
  return option ?? "ltr";
}
